/**
 * Stop contact submission dragable
 */
jQuery(document).ready(function($) {
  //$(".meta-box-sortables").sortable("disable");
  $(".postbox").removeClass("hndle").css("cursor", "default");
  $(".postbox .hndle").off("mousedown");
  $(".postbox").off("mousedown");
});

jQuery(document).ready(function ($) {
  $(window).on('load', function() {
    var currentUrl = window.location.href;

    $("#facebook-share").attr("href","https://www.facebook.com/sharer/sharer.php?u=" + encodeURIComponent(currentUrl));
    $("#linkedin-share").attr("href","https://www.linkedin.com/shareArticle?mini=true&url=" + encodeURIComponent(currentUrl));
    $("#twitter-share").attr("href","https://twitter.com/intent/tweet?url=" + encodeURIComponent(currentUrl) + "&text=Check%20this%20out!");
    $("#whatsapp-share").attr("href","https://api.whatsapp.com/send?text=Check%20this%20out!%20" + encodeURIComponent(currentUrl));
  });

  $(".caption-wrap.slider-wrap").on('click', function(){
    $(this).toggleClass('active');
  });
  
  preventScrolling();
});

function preventScrolling(){
  const iframe = document.querySelector("iframe");

  if (iframe) {
    iframe.contentWindow.addEventListener("scroll", (event) => {
      event.stopPropagation();
    });
  }
}

if (document.querySelectorAll('.custom-slider').length > 0){
  document.addEventListener('DOMContentLoaded', function () {
    var slider = tns({
      "container": '.custom-slider',
      "items": 3,
      "slideBy": 'page',
      "autoplay": true,
      "center": true,
      "speed": 400,
      "autoplayButtonOutput": false,
      "controlsText": ["Sebelumnya", "Selanjutnya"],
      "nav": false,
      "responsive": {
        320: {
          "items": 1,
          "edgePadding": 20,
          "gutter": 8,
          "mouseDrag": false,
          "swipeAngle": true,
        },
        780: {
          "items": 2,
          "edgePadding": 50,
          "gutter": 12,
          "mouseDrag": false,
          "swipeAngle": true,
        },
        1200: {
          "items": 3,
          "edgePadding": 100,
          "gutter": 16,
          "mouseDrag": true,
          "swipeAngle": false,
        },
      }
    });
  });
} else { console.error('Element with class "custom-slider" not found.'); }


/**
 * ======================================================
 * a Pen by Diaco m.lotfollahi  : https://diacodesign.com
 * ======================================================
*/ 
// import gsap from 'gsap';
// import BezierPlugin from 'gsap/gsap-bezier';

// console.log("Custom JavaScript Loaded!");

// jQuery(document).ready(function ($) {
//   console.log("DOM Loaded - Script running...");

//   if (typeof gsap !== 'undefined') {
//       console.log("GSAP loaded!");
      
//       var total = 35,
//           $container = $('#fliesGlowContainer'),
//           w = $(window).width(),
//           h = $(window).height();

//       if (!$container.length) {
//           console.error("Error: #fliesGlowContainer NOT FOUND!");
//           return;
//       }

//       console.log("Creating " + total + " dots...");
//       for (var i = 0; i < total; i++) {
//           var $div = $('<div class="dot"></div>');
//           gsap.set($div[0], { x: R(w), y: R(h), opacity: 1 });
//           $container.append($div);
//           Anim($div[0]);
//       }

//   } else {
//       console.error("GSAP is NOT loaded!");
//   }

//   function R(max) {
//       return Math.random() * max;
//   }

//   // Animation function
//   function Anim(elm) {
//       gsap.to(elm, {
//           duration: R(140) + 5,
//           x: R($(window).width()), 
//           y: R($(window).height()),
//           opacity: 1,
//           scale: R(1) + 0.5,
//           delay: R(1.5),
//           onComplete: function () {
//               Anim(elm);
//           },
//           force3D: true
//       });
//   }

//   $(window).resize(function () {
//       w = $(window).width();
//       h = $(window).height();
//   });
// });

